import { Component } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

import { ModalService } from '../../../../services/modal.service';
import { KeycloakService } from '../../../../services/keycloak.service';
import { TranslatePipe } from '../../../../pipes/translate.pipe';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'ar-ble-admin-cmp',
  templateUrl: 'admin.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, TranslatePipe, CommonModule],
})
export class ARBleAdminComponent {
  error: any;

  isAdmin = false;
  isSector = false;

  constructor(
    private modal: ModalService,
    private router: Router,
  ) {
    this.isAdmin = KeycloakService.auth.authz.hasRealmRole('ROLE_ADMIN');
    this.isSector = KeycloakService.auth.authz.hasRealmRole('ROLE_SECTOR');
  }
}
